import { FilterType } from '../../Model/Filter';
export var EncTopByFieldCondition;
(function (EncTopByFieldCondition) {
    let Operator;
    (function (Operator) {
        Operator["Bottom"] = "BOTTOM";
        Operator["Top"] = "TOP";
    })(Operator = EncTopByFieldCondition.Operator || (EncTopByFieldCondition.Operator = {}));
    let Sequence;
    (function (Sequence) {
        Sequence["FirstIsolate"] = "FIRST_ISOLATE";
        Sequence["LastIsolate"] = "LAST_ISOLATE";
    })(Sequence = EncTopByFieldCondition.Sequence || (EncTopByFieldCondition.Sequence = {}));
})(EncTopByFieldCondition || (EncTopByFieldCondition = {}));
export var EncFilterField;
(function (EncFilterField) {
    function topByField(operator, sequence, field, byField, limit) {
        return {
            ...field,
            filterType: FilterType.TopByField,
            cond: {
                operator,
                sequence,
                byField,
                limit,
            },
        };
    }
    EncFilterField.topByField = topByField;
})(EncFilterField || (EncFilterField = {}));
